import { HomeAdminView } from "components/materials/home/HomeAdminView";
import { HomeContentView } from "components/materials/home/HomeContentView";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";

export default function Page() {
  const isMdOrLarger = useIsMdOrLarger();
  if (isMdOrLarger) {
    return <HomeAdminView />;
  }
  return <HomeContentView userRole="admin" />;
}
